import { inject, Injectable } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { take } from 'rxjs';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { ModalService } from '../../../@core/services/modal/modal.service';
import { IBaseModel } from '../../../generated/generated-types';
import {
    CustomActionBarReportLauncher,
    CustomActionBarReportLaunchRequest,
} from '../../../shared/services/custom-action-bar-report-launcher';
import { PrintDialogViewAndEditComponent } from '../components/print-dialog-view-and-edit/print-dialog-view-and-edit.component';
import { ReportPrintListService } from './report-print.service';
import { ReportContext } from './type-interfaces';

/**
 * Printing-layer implementation for custom action bar REPORT items.
 */
@Injectable({
    providedIn: 'root',
})
export class CustomActionBarReportLauncherService implements CustomActionBarReportLauncher {
    private readonly modalService = inject(ModalService);
    private readonly i18nService = inject(I18nService);
    private readonly reportPrintListService = inject(ReportPrintListService);

    async openFromCustomActionBar(request: CustomActionBarReportLaunchRequest): Promise<void> {
        const report = await this.reportPrintListService.getItemData(request.reportId);
        const reportContext: ReportContext = {
            report,
            dataSource: request.model,
            entityIds: [request.model.id],
            entityFilter: this.entityNameForCustomReport(request, request.model),
            reportType: report.reportType,
        };
        this.modalService
            .fromComponent(PrintDialogViewAndEditComponent, {
                closable: true,
                size: 'lg',
                height: '100vh',
                maximizable: true,
                title: this.i18nService.translate(_('common.print')),
                setLocalsSig: {
                    reportContext,
                    showReportDropDown: false,
                },
            })
            .pipe(take(1))
            .subscribe();
    }

    private entityNameForCustomReport(
        request: CustomActionBarReportLaunchRequest,
        model: IBaseModel & { __typename?: string },
    ): string {
        const fromOpt = typeof request.entityName === 'string' ? request.entityName.trim() : '';
        if (fromOpt) {
            return fromOpt;
        }
        const typename = model.__typename;
        if (typename) {
            return typename;
        }
        return 'Document';
    }
}
